// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__DEU8N","next":"Button_next__cdH4V","prev":"Button_prev__iuttb"};